import classNames from 'classnames';
import React from 'react';
import { getLocaleLanguage, LanguageType, strToJson } from '../../../../lib';
import {
  IAPIServiceConfigItem,
  IServiceApplyConfig,
} from '../../../../model/api-modules';
import './style.scss';

interface IProps {
  readonly serviceConfig: IAPIServiceConfigItem;
  readonly onClick: (serviceID: number) => void;
  readonly renderFavoriteButton?: React.ReactNode;
  readonly viewType?: 'recommend';
}

export const SingleServiceBlockComponent = (props: IProps) => {
  const jsonConfig = strToJson<IServiceApplyConfig>(
    props.serviceConfig.JsonConfig || ''
  );
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const renderNameRow = () => {
    return (
      <div className="header-box">
        <span className="title">{props.serviceConfig.Name}</span>
        <span className="category">{props.serviceConfig.ParentName}</span>
      </div>
    );
  };

  const renderDescRow = () => {
    const jsonConfigItem = jsonConfig
      ? jsonConfig[currentStoreLanguage]
      : undefined;
    return <div className="description">{jsonConfigItem?.description}</div>;
  };

  const className = classNames('single-service-block', props.viewType);

  return (
    <div
      className={className}
      onClick={() => props.onClick(props.serviceConfig.id)}
    >
      {props.renderFavoriteButton}
      {renderNameRow()}
      {renderDescRow()}
    </div>
  );
};
